var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "addPayment",
    attrs: {
      id: "add-payment-modal",
      "modal-dialog-scrollable": false,
      "loaders-disabled": "",
      "header-class": "justify-content-center",
      "modal-dialog-size": "lg",
    },
    on: {
      show: function ($event) {
        _vm.loadingStripe = true
      },
      shown: _vm.setupStripe,
      hidden: _vm.resetModal,
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("div", { staticClass: "header-logos" }, [
              _c("div", { staticClass: "logo-wrapper" }, [
                _c("img", {
                  staticClass: "w-100",
                  attrs: {
                    height: "auto",
                    src: require("@Shared/@Assets/img/mg.png"),
                    alt: _vm.$t("global.words.filogixLogo"),
                  },
                }),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.loadingStripe
              ? _c("default-body-loader", { staticClass: "mt-5" })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.loadingStripe,
                    expression: "!loadingStripe",
                  },
                ],
                staticClass: "modal-section payment-info-modal p-0 mt-5",
              },
              [
                _c("h4", { staticClass: "bold mt-2" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("payments.addPayment")) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("p", { staticClass: "text-gray small" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("payments.messages.addPayment")) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-info" },
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-row",
                          { staticClass: "no-gutters" },
                          [
                            _c("b-col", { staticClass: "field" }, [
                              _c("div", {
                                staticClass: "input empty",
                                attrs: { id: "payment-card-number" },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "text-gray",
                                  attrs: { for: "payment-card-number" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("payments.cardInfo.cardNumber")
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "baseline" }),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "no-gutters" },
                          [
                            _c("b-col", { staticClass: "field" }, [
                              _c("div", {
                                staticClass: "input empty",
                                attrs: { id: "payment-card-expiry" },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "text-gray",
                                  attrs: { for: "payment-card-expiry" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("payments.cardInfo.expiration")
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "baseline" }),
                            ]),
                            _vm._v(" "),
                            _c("b-col", { staticClass: "field" }, [
                              _c("div", {
                                staticClass: "input empty",
                                attrs: { id: "payment-card-cvc" },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "text-gray",
                                  attrs: { for: "payment-card-cvc" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("payments.cardInfo.CVC"))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "baseline" }),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "billing-info" },
                  [
                    _c("address-section", {
                      attrs: {
                        address: _vm.address,
                        "custom-expressions": _vm.addressCustomExpressions,
                        "validator-context": _vm.$v,
                        "ignored-fields": [
                          "street-number",
                          "street-name",
                          "unit-number",
                          "street-direction",
                          "street-type",
                        ],
                      },
                      on: { change: _vm.handleAddressChange },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.paymentInfoError
                  ? _c("div", { staticClass: "payment-card-error" }, [
                      _vm._v(
                        "\n        " + _vm._s(_vm.paymentInfoError) + "\n      "
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c("simple-button", {
              attrs: {
                disabled: _vm.$v.$invalid,
                text: _vm.$t("payments.addPayment"),
                loading: _vm.loading,
                "loading-succeeded": _vm.loadingSucceeded,
              },
              on: {
                finish: _vm.addPaymentButtonFinish,
                click: _vm.addPaymentMethod,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }